<template>
  <div>
    <my-header></my-header>

    <router-view></router-view>

    <my-sider></my-sider>
    <my-footer></my-footer>
  </div>
</template>

<script>
  import Home from './views/Home'
  import MyFooter from "./components/MyFooter";
  import MySider from "./components/MySider";
  import MyHeader from "./components/MyHeader";
  import {animateOnScroll} from 'mdbvue';


  export default {
    name: 'myApp',
    components: {MyHeader, MySider, MyFooter, Home, animateOnScroll},
    beforeRouteEnter(to, from, next) {
      window.document.body.style.background = '';
      window.document.body.style.backgroundRepeat = 'no-repeat';
      window.document.body.style.backgroundSize = 'cover';
      window.document.body.style.backgroundAttachment = 'fixed'
      next();
    },
    beforeRouteLeave(to, from, next) {
      window.document.body.style.backgroundImage = '';
      next();
    }
  }
</script>

<style lang="scss">
  $image-path: '~@/../mdb/mdbvue/img';
  @import './mdb/mdbvue/scss/mdb-pro.scss';
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');


  .mybody {
    background-image: url("./assets/images/index/bg-cloud.jpg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow-y: auto;
  }


</style>
